export interface IMenuLink {
  name: string;
  title: string;
  trackingLabel?: string;
  path?: string[];
  section?: string;
}

export const MENU_LINKS: IMenuLink[] = [
  {
    name: 'rent',
    title: 'Аренда',
    trackingLabel: 'rent',
    path: ['listingLinks', 'rent'],
    section: 'rent',
  },
  {
    name: 'sale',
    title: 'Продажа',
    trackingLabel: 'sale',
    path: ['listingLinks', 'sale'],
    section: 'sale',
  },
  {
    name: 'newbuildings',
    title: 'Новостройки',
    trackingLabel: 'newobjects',
    path: ['listingLinks', 'newobjects'],
    section: 'new-buildings',
  },
  {
    name: 'commercial',
    title: 'Коммерческая',
    trackingLabel: 'commercial',
    path: ['listingLinks', 'commercial'],
    section: 'commercial',
  },
  {
    name: 'calculator',
    title: 'Оценка',
    trackingLabel: 'estimation',
    path: ['otherLinks', 'calculator'],
    section: 'valuation',
  },
  {
    name: 'mortgage',
    title: 'Ипотека',
    trackingLabel: 'mortgage',
    path: ['mortgageLinks', 'main'],
  },
  {
    name: 'additional1024px',
    title: 'Ещё',
  },
  {
    name: 'additional1093px',
    title: 'Ещё',
  },
];
